// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React from 'react';
import { DatasetFilterType } from 'components/project/data/filter/filters-defaults';
import IconEvaluation from 'components/treactui-template/icons/IconEvaluation';
import IconTraining from 'components/treactui-template/icons/IconTraining';

interface Props {
  dataset: DatasetFilterType;
  size: string;
}

export default function DatasetTag({ dataset, size }: Readonly<Props>) {
  switch (dataset) {
    case DatasetFilterType.EvaluationSet:
      return <IconEvaluation width={size} height={size} />;
    case DatasetFilterType.TrainingSet:
      return <IconTraining width={size} height={size} />;
    default:
      return <div style={{ width: size, height: size }} />;
  }
}
